// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import dayjs from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/dayjs@1.11.20/node_modules/dayjs';
import antdPlugin from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/antd-dayjs-webpack-plugin@1.0.6_dayjs@1.11.20/node_modules/antd-dayjs-webpack-plugin/src/antd-plugin.js';

import isSameOrBefore from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/dayjs@1.11.20/node_modules/dayjs/plugin/isSameOrBefore';
import isSameOrAfter from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/dayjs@1.11.20/node_modules/dayjs/plugin/isSameOrAfter';
import advancedFormat from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/dayjs@1.11.20/node_modules/dayjs/plugin/advancedFormat';
import customParseFormat from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/dayjs@1.11.20/node_modules/dayjs/plugin/customParseFormat';
import weekday from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/dayjs@1.11.20/node_modules/dayjs/plugin/weekday';
import weekYear from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/dayjs@1.11.20/node_modules/dayjs/plugin/weekYear';
import weekOfYear from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/dayjs@1.11.20/node_modules/dayjs/plugin/weekOfYear';
import isMoment from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/dayjs@1.11.20/node_modules/dayjs/plugin/isMoment';
import localeData from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/dayjs@1.11.20/node_modules/dayjs/plugin/localeData';
import localizedFormat from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/dayjs@1.11.20/node_modules/dayjs/plugin/localizedFormat';
import duration from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/dayjs@1.11.20/node_modules/dayjs/plugin/duration';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(weekYear);
dayjs.extend(weekOfYear);
dayjs.extend(isMoment);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(duration);

dayjs.extend(antdPlugin);
